import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  DateLabelNullable,
  DateType,
  DateUnit,
  NullableDate,
} from "@/services/cloudchipr.api";
import { currentDashboardIdSelector } from "@/store/dashboards/selectors/dashboard/currentDashboardIdSelector";
import { dashboardDatesByDashboardIdSelector } from "@/store/dashboards/selectors/dashboard/filters/dashboardDatesByDashboardIdSelector";
import { dashboardDimensionsCategoryIdsByDashboardIdSelector } from "@/store/dashboards/selectors/dashboard/filters/dashboardDimensionsCategoryIdsByDashboardIdSelector";
import { covertDatesToQueryParam } from "@/components/common/date-range-picker/utils/helpers/covertDatesToQueryParam";
import { RootState } from "@/store/store";
import { widgetInheritsDatesByIdSelector } from "@/store/dashboards/selectors/widgets/common/widgetInheritsDatesByIdSelector";

export const generateWidgetDataGetterPayloadThunk = createAsyncThunk(
  "dashboards/generateWidgetDataGetterPayload",
  async (widgetId: string, { getState }) => {
    const state = getState() as RootState;

    const dashboardId = currentDashboardIdSelector(state);

    if (!dashboardId) {
      return;
    }

    const dashboardDates = dashboardDatesByDashboardIdSelector(
      state,
      dashboardId,
    );

    const categoryId = dashboardDimensionsCategoryIdsByDashboardIdSelector(
      state,
      dashboardId,
    )?.category_id;

    let payload: {
      widgetId: string;
      categoryId?: string;
      dateLabel?: DateLabelNullable;
      dateFrom?: NullableDate;
      dateTo?: NullableDate;
      dateType?: DateType;
      dateValue?: number | null;
      dateUnit?: DateUnit;
    } = {
      widgetId,
    };

    const inheritDates = widgetInheritsDatesByIdSelector(state, widgetId);

    if (inheritDates && dashboardDates) {
      payload = {
        ...payload,
        ...covertDatesToQueryParam(dashboardDates),
      };
    }

    if (categoryId) {
      payload.categoryId = categoryId;
    }

    return payload;
  },
);
